import { merge } from 'lodash'
import { lib } from '@giscube/geoportal'

const except = lib.except
const notifications = lib.notifications
const notifyError = notifications.notifyError

export default async ({ Vue, store }) => {
  const config = Vue.prototype.$config
  except._log = function (error, vueConfig) {
    if (error.message === 'ResizeObserver loop limit exceeded') {
      return
    }
    if (vueConfig !== void 0) {
      except._vue(error, ...vueConfig)
    }
    console.error(error)
  }
  except._notify = function (error) {
    if (error.message === 'ResizeObserver loop limit exceeded') {
      return
    }
    if (!config.except.silent) {
      notifyError.apply(null, arguments)
    }
  }
  merge(except.config, config.except || {})

  window.addEventListener('error', except)
  window.addEventListener('unhandledrejection', e => e.promise.catch(except))
  Vue.config.errorHandler = except.vue

  // Sentry setup
  if (process.env.NODE_ENV === 'production' && config.sentry.dsn) {
    const Sentry = require('@sentry/browser')
    const Integrations = require('@sentry/integrations')

    Sentry.init({
      dsn: config.sentry.dsn,
      integrations: [new Integrations.Vue({ Vue })]
    })

    except.setSentry(Sentry)
  }

  // Shortcut
  Vue.prototype.$except = except
  store.$except = except
}
